<template lang="pug" src="./sqlReportsList.pug"></template>
<style lang="scss" src="./sqlReportsList.scss" scoped></style>

<script>
import { mapState, mapGetters } from 'vuex'
import scroll from '@/utils/scroll'

export default {
    data: () => ({
        filters: {
            fromDate: null,
            toDate: null,
            sqlQuery: null
        }
    }),
    computed: {
        ...mapGetters(['permissions']),
        ...mapState({
            pagination: state => state.sqlReports.pagination,
            isTableLoad: state => state.sqlReports.loading,
            reports: state => state.sqlReports.reports,
            appliedFilters: state => state.sqlReports.reportsListFilters
        }),

        headers() {
            return ['#', 'name', 'category', 'sqlQuery', 'forLeader', 'created', 'updated', 'actions'].map(it => ({
                text: this.$vuetify.t(`$vuetify.pages.ExtendedReports.List.table.${it}`),
                value: it,
                sortable: false,
                align: 'center'
            }))
        },

        canEditExtendedReports() {
            return this.permissions && this.permissions.includes('edit-extended-reports')
        }
    },
    created() {
        this.filters = Object.assign({}, this.appliedFilters)
        this.getReportsByPage()
    },
    methods: {
        changeToDate(date) {
            this.filters.toDate = date
        },
        changeFromDate(date) {
            this.filters.fromDate = date
        },
        getReportsByPage(page = 1, isScrollEnable = false) {
            this.$store.dispatch('sqlReports/getReports', {
                page,
                ...this.appliedFilters
            }).then(_ => {
                if (isScrollEnable) {
                    scroll(this.$refs.table)
                }
            })
        },
        submit() {
            this.$store.commit('sqlReports/SET_REPORTS_LIST_FILTERS', Object.assign({}, this.filters))
            this.getReportsByPage()
        },
        reset() {
            this.filters = Object.assign({}, {
                fromDate: null,
                toDate: null,
                sqlQuery: null
            })
            this.$store.commit('sqlReports/RESET_REPORTS_LIST_FILTERS')
            this.getReportsByPage()
        },
        onPageChange(page) {
            if (page !== this.pagination.page) {
                this.getReportsByPage(page, true)
            }
        },
        openEditor(id) {
            const url = id ? `editor/${id}` : 'editor'
            this.$router.push(`/extended-reports/${url}`)
        }
    }
}
</script>
